module.exports = __webpack_public_path__ + "img/ID.488ad10f.svg";